import React from 'react';


const ingresos = () =>{
  return(
    <div>
        <h1>Tela de Ingresos!</h1>
        <p>Convence é uma plataforma moderna e tecnológica para organização, divulgação e gerenciamento de eventos. Criada para facilitar a comunicação entre organizadores e participantes, a plataforma oferece recursos completos para controle de inscrições, feedback e análise de desempenho, tudo em uma interface elegante e responsiva.
        </p>
    </div>
  
  );  
}

export default ingresos;